import React, { createContext, useContext, useMemo } from "react";

import type { SidebarItemLabelSize } from "./sidebar-menu.types";

interface SidebarContextValue {
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  itemLabelSize: SidebarItemLabelSize;
}

const SidebarContext = createContext<SidebarContextValue | undefined>(undefined);

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("Sidebar sub-components must be used within a <SidebarMenu />");
  }
  return context;
};

interface SidebarProviderProps {
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  itemLabelSize?: SidebarItemLabelSize;
  children: React.ReactNode;
}

export const SidebarProvider = ({
  isCollapsed,
  onToggleCollapse,
  itemLabelSize = "default",
  children,
}: SidebarProviderProps) => {
  const value = useMemo(
    () => ({
      isCollapsed,
      onToggleCollapse,
      itemLabelSize,
    }),
    [isCollapsed, onToggleCollapse, itemLabelSize],
  );

  return <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>;
};
